import HTTP from '@/utils/http'
const http = new HTTP()

export default class DCModel extends HTTP {
  query(data) {
    return this.post({
      url: '/datacenter/query',
      data,
    })
  }
}

/** bi 分页接口
 *  {
      "name": "mall_class_lesson_complete_info_AT",
      "pageNum":1,
      "pageSize":10,
      "page":false,
      "params": {
        "classId":367,
        "pushTime":"2023-07-15",
        "type":100
      }
    }
 *
 */
export function apiQueryDataPage(data) {
  return http.post({
    url: '/datacenter/queryPage',
    data,
  })
}